// Auto-generated from learn.html. Verbatim redesign import. Do NOT edit.
export const SCRIPT = `
(function(){
  // hero constellation canvas
  var cv=document.getElementById('lrnHeroCanvas');
  var reducedH=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(cv && !reducedH){
    var ctx=cv.getContext('2d'), W,H,DPR,nodes,hubs,raf2,t=0,running2=false;
    function size(){ DPR=Math.min(window.devicePixelRatio||1,2); var r=cv.getBoundingClientRect(); W=r.width;H=r.height; cv.width=W*DPR;cv.height=H*DPR; ctx.setTransform(DPR,0,0,DPR,0,0); }
    function build(){ var n=Math.round(Math.min(96,Math.max(40,W/18))); nodes=[]; for(var i=0;i<n;i++){ nodes.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-0.5)*0.20,vy:(Math.random()-0.5)*0.20,r:Math.random()*1.8+0.8}); }
      hubs=[]; var hn=Math.max(3,Math.round(W/520));
      for(var h=0;h<hn;h++){ hubs.push({x:(0.12+0.76*Math.random())*W,y:(0.16+0.7*Math.random())*H,vx:(Math.random()-0.5)*0.08,vy:(Math.random()-0.5)*0.08,ph:Math.random()*Math.PI*2}); } }
    var LINK=190;
    function frame(){ t+=0.004; ctx.clearRect(0,0,W,H);
      for(var i=0;i<nodes.length;i++){ var p=nodes[i]; p.x+=p.vx;p.y+=p.vy; if(p.x<0||p.x>W)p.vx*=-1; if(p.y<0||p.y>H)p.vy*=-1; }
      for(var hh=0;hh<hubs.length;hh++){ var hb=hubs[hh]; hb.x+=hb.vx; hb.y+=hb.vy; if(hb.x<0||hb.x>W)hb.vx*=-1; if(hb.y<0||hb.y>H)hb.vy*=-1; }
      for(var a=0;a<nodes.length;a++){ for(var b=a+1;b<nodes.length;b++){ var dx=nodes[a].x-nodes[b].x,dy=nodes[a].y-nodes[b].y,d=Math.sqrt(dx*dx+dy*dy);
        if(d<LINK){ var al=(1-d/LINK)*0.30; ctx.strokeStyle='rgba(232,217,184,'+al.toFixed(3)+')'; ctx.lineWidth=0.7; ctx.beginPath(); ctx.moveTo(nodes[a].x,nodes[a].y); ctx.lineTo(nodes[b].x,nodes[b].y); ctx.stroke();
          var seed=(a*7+b*13)%17; var pp=((t*0.4)+seed/17)%1;
          if(d<LINK*0.85){ var px=nodes[a].x+(nodes[b].x-nodes[a].x)*pp, py=nodes[a].y+(nodes[b].y-nodes[a].y)*pp; var pa=(1-d/LINK)*Math.sin(pp*Math.PI)*0.5;
            ctx.fillStyle='rgba(255,122,51,'+pa.toFixed(3)+')'; ctx.beginPath(); ctx.arc(px,py,1.4,0,Math.PI*2); ctx.fill(); } } } }
      for(var g=0;g<hubs.length;g++){ var H0=hubs[g], pulse0=0.5+0.5*Math.sin(t*2.2+H0.ph);
        for(var m=0;m<nodes.length;m++){ var ddx=H0.x-nodes[m].x,ddy=H0.y-nodes[m].y,dd=Math.sqrt(ddx*ddx+ddy*ddy);
          if(dd<LINK*1.15){ var hal=(1-dd/(LINK*1.15))*0.24; ctx.strokeStyle='rgba(168,139,74,'+hal.toFixed(3)+')'; ctx.lineWidth=0.8; ctx.beginPath(); ctx.moveTo(H0.x,H0.y); ctx.lineTo(nodes[m].x,nodes[m].y); ctx.stroke(); } }
        ctx.fillStyle='rgba(168,139,74,'+(0.55+pulse0*0.22).toFixed(3)+')'; ctx.beginPath(); ctx.arc(H0.x,H0.y,2.4+pulse0*1.0,0,Math.PI*2); ctx.fill(); }
      for(var k=0;k<nodes.length;k++){ var q=nodes[k], pulse=0.5+0.5*Math.sin(t*6+k); ctx.fillStyle='rgba(168,139,74,'+(0.30+pulse*0.26).toFixed(3)+')'; ctx.beginPath(); ctx.arc(q.x,q.y,q.r,0,Math.PI*2); ctx.fill(); }
      if(running2) raf2=requestAnimationFrame(frame);
    }
    function start2(){ if(running2)return; running2=true; raf2=requestAnimationFrame(frame); }
    function stop2(){ running2=false; cancelAnimationFrame(raf2); }
    size(); build(); start2();
    window.addEventListener('resize',function(){ size(); build(); });
    if('IntersectionObserver' in window){ var hio=new IntersectionObserver(function(es){es.forEach(function(e){ e.isIntersecting?start2():stop2(); });},{threshold:0.01}); hio.observe(cv); }
  }
  // cycling word in the hero headline (crossfade)
  (function(){
    var roles=["tokenization","ERC-3643","the Ledger","compliance","the Network"];
    var track=document.getElementById('lrnCycTrack'), wrap=document.getElementById('lrnCyc'), measure=document.getElementById('lrnCycMeasure');
    if(!track||!wrap||!measure) return;
    var spans=roles.map(function(w){ var s=document.createElement('span'); s.className='w'; s.textContent=w; track.appendChild(s); return s; });
    var idx=0;
    function measureWord(w){ measure.textContent=w; measure.style.fontSize=getComputedStyle(wrap).fontSize; return measure.getBoundingClientRect().width; }
    function setWidth(w){ if(window.matchMedia('(max-width: 760px)').matches){ wrap.style.width=''; return; } wrap.style.width=(Math.ceil(measureWord(w))+3)+'px'; }
    function show(i){ spans.forEach(function(s,k){ s.classList.remove('is-in','is-out'); if(k===i) s.classList.add('is-in'); }); setWidth(roles[i]); }
    show(0); window.addEventListener('load',function(){ setWidth(roles[idx]); }); window.addEventListener('resize',function(){ setWidth(roles[idx]); });
    var reducedC=window.matchMedia('(prefers-reduced-motion: reduce)').matches; if(reducedC) return;
    setInterval(function(){
      var prev=idx; idx=(idx+1)%roles.length;
      spans[prev].classList.remove('is-in'); spans[prev].classList.add('is-out');
      spans[idx].classList.remove('is-out'); spans[idx].classList.add('is-in');
      setWidth(roles[idx]);
    },2600);
  })();
  // reveal-up (document-scoped: the Learn page isn't wrapped in .ix-scope)
  var reduced=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var ups=document.querySelectorAll('.reveal-up');
  if('IntersectionObserver' in window && !reduced){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });},{threshold:0.16,rootMargin:'0px 0px -8% 0px'});
    ups.forEach(function(el){io.observe(el);});
  } else { ups.forEach(function(el){el.classList.add('in');}); }

  // Staggered grid reveals: cards inside .ix-entry-grid, .ix-flow (rail),
  // .ix-art-grid, .ix-term-grid and .ix-res-grid fade in one after another
  // when the grid scrolls into view. Adds .reveal-item to each card so the
  // existing .reveal-up transition kicks in, staggered via inline delay.
  var gridSelectors=['.ix-entry-grid > .ix-entry','.ix-flow > .ix-flow-step','.ix-art-grid > .ix-art','.ix-term-grid > .ix-term','.ix-res-grid > .ix-res'];
  var groups={};
  gridSelectors.forEach(function(sel){
    document.querySelectorAll(sel).forEach(function(el){
      el.classList.add('reveal-item');
      var parent=el.parentElement;
      var key=parent && (parent.className||'anon');
      if(!groups[key]) groups[key]=[];
      groups[key].push(el);
    });
  });
  if('IntersectionObserver' in window && !reduced){
    Object.keys(groups).forEach(function(key){
      var items=groups[key]; if(!items.length) return;
      var parent=items[0].parentElement; if(!parent) return;
      var gio=new IntersectionObserver(function(es){
        es.forEach(function(e){
          if(e.isIntersecting){
            items.forEach(function(item,i){
              item.style.transitionDelay=Math.min(i*80,560)+'ms';
              requestAnimationFrame(function(){ item.classList.add('in'); });
            });
            gio.disconnect();
          }
        });
      },{threshold:0,rootMargin:'0px 0px -6% 0px'});
      gio.observe(parent);
    });
  } else {
    Object.keys(groups).forEach(function(key){
      groups[key].forEach(function(item){ item.classList.add('in'); });
    });
  }
})();
`;
